import { EProductTourTargets } from '@constants';
import { useTranslation } from 'react-i18next';

import {
  ShowMoreButton,
  TitleWrapper,
  WidgetTitle,
  WidgetWrapper
} from '../shared/WidgetShared.styles';

import { CoursesWrapper } from './SubscriptionsWidget.styles';

import {
  SubscriptionCard,
  SubscriptionSelectionModal
} from '@/components/SubscriptionSelectionModal';
import { useMySubscriptions } from '@/store';

export const SubscriptionsWidget: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  const { filteredSubscriptions, setIsOpen, lastFourSubscriptions } = useMySubscriptions();
  const handleChangeCourse = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsOpen(true);
  };
  if (!filteredSubscriptions || filteredSubscriptions.length <= 1) return null;

  const showedSubscriptions =
    lastFourSubscriptions.length < 2 ? filteredSubscriptions?.slice(0, 4) : lastFourSubscriptions;
  return (
    <WidgetWrapper id={EProductTourTargets.SUBSCRIPTIONS_WIDGET}>
      <TitleWrapper>
        <WidgetTitle>{t('COURSES')}</WidgetTitle>
        <ShowMoreButton type="text" onClick={handleChangeCourse}>
          {t('SEE_ALL')}
        </ShowMoreButton>
      </TitleWrapper>
      <CoursesWrapper>
        {showedSubscriptions.map(subscription => (
          <SubscriptionCard key={subscription._id} subscription={subscription} />
        ))}
      </CoursesWrapper>
      <SubscriptionSelectionModal />
    </WidgetWrapper>
  );
};
